import { TabBar } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';
import { SettingsSubjectContainersSubpage } from './SettingsSubjectContainersSubpage';
import { SettingsSubjectGroupsSubpage } from './SettingsSubjectGroupsSubpage';
import { SettingsSubjectsSubpage } from './SettingsSubjectsSubpage';

export const SettingsSetupSubjectsAndSubjectContainer = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()}>
      <TabBar
        variant='large'
        tabs={[
          {
            trigger: t('subject.title', { count: 2 }),
            id: 'subjects',
            content: <SettingsSubjectsSubpage />,
          },
          {
            trigger: t('subjectContainer.title', { count: 2 }),
            id: 'subjectsContainer',
            content: <SettingsSubjectContainersSubpage />,
          },
          {
            trigger: t('subjectGroup.title', { count: 2 }),
            id: 'subjectGroup',
            content: <SettingsSubjectGroupsSubpage />,
          },
        ]}
      />
    </Page>
  );
};
